export const convertPunctuationToBackslash = name =>
  name.includes(':') ? name.replace(/:/g, '/') : name;
